import { Button, Typography } from "@mui/material";
import { DeleteIcon, EditIcon, DownIcon } from "../../assets/common-svg/CommonSvg";
import { RolesCard } from "../../components/custom-card/RolesCard";
import { useLocation, useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import RolesApi from "../../services/rolesManagemant";
import { useSelector } from "react-redux";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import DeleteConfirmContent from "../../components/modal-contents/DeleteConfirmModalContent";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import { getUserHasAccess } from "../../utils/authorities";
import { notify } from "../../bmr/utils/methods/notification";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  FormGroup,
  Grid,
} from "@mui/material";
import IosSwitch from "../../bmr/components/styled/Switch";

const RolesDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const roleEditId = id;
  const LoginData = useSelector((state) => state.loginData);
  const userAuthority = LoginData?.auth || [];
  const [deleteModal, setDeleteModal] = useState(false);
  const [rowId, setRowId] = useState("");
  const [RolesState, setRolesState] = useState({ modules: [] });
  const [RolesDetails, setRolesDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  // Separate state for is_table modules (e.g. Change Request)
  const [tableModules, setTableModules] = useState([]);
  // Track selected table action generated IDs
  const [tablePermIds, setTablePermIds] = useState([]);

  const normalizeApheresisText = (value = "") =>
    value.replace(/aphresis/gi, (match) =>
      match[0] === match[0].toUpperCase() ? "Apheresis" : "apheresis"
    );

  const getDetails = () => {
    setLoading(true);
    RolesApi.getRoleModulesDetails(roleEditId)
      .then((res) => {
        if (res && res.status === 200 && res.data) {
          const modules = [];
          const tableMods = [];
          let stateModule = [];
          const initTablePermIds = [];

          res.data.modules.forEach((op) => {
            if (op.is_table) {
              // Deep clone to avoid Redux/state mutation
              const clonedOp = JSON.parse(JSON.stringify(op));
              clonedOp.permissions?.forEach((p) => {
                if (p.actions) {
                  Object.keys(p.actions).forEach((k, idx) => {
                    const genId = parseInt(`${p.change_type_id}0${idx + 1}`);
                    if (p.actions[k] === 1) {
                      p.actions[k] = genId;
                      initTablePermIds.push(genId); // pre-select active actions
                    } else {
                      p.actions[k] = genId;
                    }
                  });
                }
              });
              tableMods.push(clonedOp);
            } else {
              let subCard = [];
              op.permissions.forEach((p, index) => {
                let obj = {
                  id: p.id,
                  module_id: op.module_id,
                  permission_id: p.permission_id,
                  label: p.name,
                  name: p.description,
                  disabled: index === 0,
                };
                if (p.checked) {
                  subCard.push(obj);
                  stateModule.push(obj);
                } else {
                  subCard.push(obj);
                }
              });
              modules.push({
                id: op.id,
                module_id: op.module_id,
                title: op.module_name,
                toggle: false,
                subCard,
              });
            }
          });

          setTimeout(() => {
            setRolesState({ modules: stateModule });
            setRolesDetails({ ...res.data, modules });
            setTableModules(tableMods);
            setTablePermIds(initTablePermIds);
            setLoading(false);
          }, 1000);
        } else {
          notify.error(res?.message || "An error occurred");
          setLoading(false);
        }
      })
      .catch((err) => {
        notify.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getDetails();
  }, []);

  // Toggle a single table action switch
  const handleTableActionToggle = (actionId, checked) => {
    setTablePermIds((prev) =>
      checked ? [...prev, actionId] : prev.filter((id) => id !== actionId)
    );
  };

  // Master toggle for all actions in a table module
  const handleTableModuleMasterToggle = (mod, checked) => {
    const allIds = [];
    (mod.permissions || []).forEach((p) => {
      if (p.actions) Object.values(p.actions).forEach((id) => allIds.push(id));
    });
    setTablePermIds((prev) => {
      if (checked) {
        const merged = [...prev];
        allIds.forEach((id) => { if (!merged.includes(id)) merged.push(id); });
        return merged;
      }
      return prev.filter((id) => !allIds.includes(id));
    });
  };

  const handleSwitch = (e, index, rootIndex) => {
    const { checked } = e.target;
    let modules = [...RolesState.modules];
    if (checked) {
      modules = [...modules, RolesDetails?.modules[rootIndex].subCard[index]];
    } else {
      modules = modules.filter(
        (op) => op.id !== RolesDetails?.modules[rootIndex].subCard[index]?.id
      );
    }
    setRolesState({ ...RolesState, modules });
  };

  const handleRootSwitch = (e, index) => {
    const { checked } = e.target;
    const roleCard = RolesDetails?.modules.map((card, moduleIndex) => {
      if (index === moduleIndex) return { ...card, toggle: checked };
      return card;
    });
    if (checked) {
      const Modules =
        RolesDetails?.modules[index]?.subCard.filter((_, i) => i !== 0) || [];
      setRolesState((prevState) => {
        const newModules = Modules.filter(
          (newModule) =>
            !prevState.modules.some((existing) => existing.id === newModule.id)
        );
        return { ...prevState, modules: [...prevState.modules, ...newModules] };
      });
    } else {
      setRolesState((prevState) => ({
        ...prevState,
        modules: prevState.modules.filter(
          (op) =>
            !RolesDetails?.modules[index]?.subCard
              .filter((_, i) => i !== 0)
              .some((p) => op.id === p?.id)
        ),
      }));
    }
    setRolesDetails({ ...RolesDetails, modules: roleCard });
  };

  const handleUpdate = () => {
    setSubmitLoading(true);

    // Build table_config from tablePermIds by reversing the genId mapping
    const table_config = [];
    tableModules.forEach((mod) => {
      const tablePerms = [];
      (mod.permissions || []).forEach((perm) => {
        const selectedActions = [];
        if (perm.actions) {
          Object.keys(perm.actions).forEach((action) => {
            const actionId = perm.actions[action];
            if (tablePermIds.includes(actionId)) {
              selectedActions.push(
                action.charAt(0).toUpperCase() + action.slice(1).toLowerCase()
              );
            }
          });
        }
        if (selectedActions.length > 0) {
          tablePerms.push({
            change_type_id: perm.change_type_id,
            actions: selectedActions,
          });
        }
      });
      if (tablePerms.length > 0) {
        table_config.push({ key: mod.module_name, permissions: tablePerms });
      }
    });

    const data = {
      role_id: RolesDetails?.id,
      permissionIds: RolesState?.modules.map((op) => op?.id),
      table_config,
    };

    RolesApi.assignPermissionsToRole(data)
      .then((res) => {
        notify.success(res?.message);
        navigate("/roles-management", { state: [] });
        setTimeout(() => setSubmitLoading(false), 300);
      })
      .catch((err) => {
        notify.error(err);
        setLoading(false);
        setSubmitLoading(false);
      });
  };

  const handleEdit = (id) => {
    navigate(`/roles-management/edit-modules-management/${id}`, {
      state: [
        { name: "Permission", path: "/roles-management" },
        { name: "Edit Role", path: location.pathname },
      ],
    });
  };

  const handleDelete = () => {
    setLoading(true);
    setSubmitLoading(true);
    RolesApi.deleteRole(rowId)
      .then((res) => {
        notify.success(res?.message);
        navigate("/roles-management", { state: [] });
        setTimeout(() => setSubmitLoading(false), 300);
      })
      .catch((err) => {
        notify.error(err);
        setLoading(false);
        setSubmitLoading(false);
      });
  };

  const checkEnableButton = () => {
    let checkStateCount = {};
    RolesState?.modules.forEach((permission) => {
      const moduleId = permission.module_id;
      if (checkStateCount[moduleId]) {
        checkStateCount[moduleId].count++;
      } else {
        checkStateCount[moduleId] = { count: 1 };
      }
    });
    const roleCard = RolesDetails?.modules?.map((card) => {
      if (checkStateCount[card?.module_id]?.count === card.subCard.length) {
        return { ...card, toggle: true };
      }
      return { ...card, toggle: false };
    });
    setRolesDetails({ ...RolesDetails, modules: roleCard });
  };

  useEffect(() => {
    checkEnableButton();
  }, [RolesState?.modules]);

  return (
    <div className="p-4">
      <div className="mb-0 md:mb-4">
        <BreadCrumb
          BreadCrumbsListing={[
            { name: "Permission", path: "roles-management" },
            { name: "Role Details", path: location.pathname },
          ]}
        />
      </div>

      {loading ? (
        <SkeletonLoader rowCount={1} isTable={false} width={"100%"} height={90} />
      ) : (
        <div className="p-4 mt-3 rounded-xl bg-[#171928] align-items-center flex justify-content-between">
          <div className="flex flex-col gap-3">
            <Typography variant="h4" color="white">
              {RolesDetails?.title}
            </Typography>
            <div className="flex gap-3">
              {getUserHasAccess(userAuthority, "rolesManagement", 97) && (
                <Button
                  variant="contained"
                  className="bg-[#333B4A] text-[0.8rem]"
                  onClick={() => handleEdit(RolesDetails?.id)}
                  startIcon={<EditIcon filled="white" Width="1rem" Height="1rem" />}
                >
                  Edit
                </Button>
              )}
              {!RolesDetails?.predefined_role &&
                getUserHasAccess(userAuthority, "rolesManagement", 99) && (
                  <Button
                    variant="contained"
                    className="bg-[#333B4A] text-[0.8rem]"
                    startIcon={<DeleteIcon filled="white" Width="1rem" Height="1rem" />}
                    onClick={() => {
                      setRowId(RolesDetails?.id);
                      setDeleteModal(true);
                    }}
                  >
                    Delete
                  </Button>
                )}
            </div>
          </div>
          <div className="flex flex-col gap-2 align-items-center">
            <Typography className="text-sm md:text-base" variant="body2" color="white">
              {RolesDetails?.modulesCount}
            </Typography>
            <Typography className="text-sm md:text-base" variant="body2" color="secondary">
              Assigned Module
            </Typography>
          </div>
        </div>
      )}

      <div className="bg-white rounded-xl p-3 mt-3">
        <Typography variant="h5">Role Permissions</Typography>
        <div className="flex flex-col gap-3 pt-3">
          {/* Standard modules rendered via RolesCard */}
          <RolesCard
            loading={loading}
            disableChip={!getUserHasAccess(userAuthority, "rolesManagement", 100)}
            rolesCardData={RolesDetails?.modules}
            selected={RolesState?.modules}
            handleRootSwitch={handleRootSwitch}
            handleSwitch={handleSwitch}
            activeRoleId={RolesDetails?.id}
          />

          {/* Table modules (is_table === true) rendered as accordion table */}
          {!loading &&
            tableModules.map((mod, modIdx) => {
              // Collect all unique action column names from permissions
              const actionsSet = new Set();
              (mod.permissions || []).forEach((perm) => {
                if (perm.actions) Object.keys(perm.actions).forEach((k) => actionsSet.add(k));
              });
              const actions = Array.from(actionsSet);

              // All generated IDs for master toggle
              const allIds = [];
              (mod.permissions || []).forEach((p) => {
                if (p.actions) Object.values(p.actions).forEach((id) => allIds.push(id));
              });
              const isMasterChecked =
                allIds.length > 0 && allIds.every((id) => tablePermIds.includes(id));

              return (
                <Box key={modIdx} className="border border-gray-200 p-3 rounded-md mt-3">
                  <Grid container spacing={2} className="p-3">
                    <Grid item xs={12}>
                      {/* Module header with master toggle */}
                      <div className="flex justify-content-between align-items-center mb-2">
                        <Typography variant="h5">{mod.module_name}</Typography>
                        <FormGroup>
                          <FormControlLabel
                            control={<IosSwitch checked={isMasterChecked} />}
                            onChange={(e) =>
                              handleTableModuleMasterToggle(mod, e.target.checked)
                            }
                          />
                        </FormGroup>
                      </div>

                      {/* Accordion table */}
                      <Accordion defaultExpanded className="w-100 mt-2">
                        <AccordionSummary
                          expandIcon={
                            <div className="d-flex gap-3 align-items-center">
                              <DownIcon />
                            </div>
                          }
                          aria-controls={`table-panel-${modIdx}`}
                          id={`table-header-${modIdx}`}
                        >
                          <Typography component="span">{mod.module_name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails className="p-0">
                          <Box className="w-100 px-3 pb-3">
                            {/* Table Column Headers */}
                            <Box className="flex justify-content-between p-3 bg-[#f0f2f5] rounded-t-[6px] text-[#555a68] font-bold text-[13px]">
                              <Box className="w-[40%] shrink-0 text-left">
                                {mod.module_name} Name
                              </Box>
                              {actions.map((action) => (
                                <Box
                                  key={action}
                                  className="flex-1 text-center flex justify-center"
                                >
                                  {action.charAt(0).toUpperCase() +
                                    action.slice(1).toLowerCase()}
                                </Box>
                              ))}
                            </Box>

                            {/* Table Rows */}
                            {(mod.permissions || []).map((perm, idx) => (
                              <Box
                                key={idx}
                                className="flex justify-content-between align-items-center p-3 border-b border-gray-200 border-x last:rounded-b-[6px]"
                              >
                                <Box className="w-[40%] shrink-0 text-[#333] text-[13px] font-medium text-left pr-2">
                                    {normalizeApheresisText(perm.name)}
                                </Box>
                                {actions.map((action) => (
                                  <Box key={action} className="flex-1 flex justify-center">
                                    {perm.actions &&
                                    perm.actions[action] !== undefined ? (
                                      <FormControlLabel
                                        className="m-0"
                                        control={
                                          <IosSwitch
                                            checked={tablePermIds.includes(
                                              perm.actions[action]
                                            )}
                                            onChange={(e) =>
                                              handleTableActionToggle(
                                                perm.actions[action],
                                                e.target.checked
                                              )
                                            }
                                          />
                                        }
                                      />
                                    ) : null}
                                  </Box>
                                ))}
                              </Box>
                            ))}
                          </Box>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
        </div>

        <div className="pt-3 text-left">
          {loading ? (
            <SkeletonLoader rowCount={1} isTable={false} width={"10%"} height={25} />
          ) : (
            <Button
              size="large"
              type="submit"
              disabled={submitLoading}
              onClick={() => handleUpdate()}
            >
              Update
            </Button>
          )}
        </div>
      </div>

      <DeleteConfirmContent
        open={deleteModal}
        setOpen={setDeleteModal}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default RolesDetails;
